
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ModellingViewColumnSetDialog extends SiteEntityDialog<ModellingViewColumnSetRow, any> {
        protected getFormKey() { return ModellingViewColumnSetForm.formKey; }
        protected getIdProperty() { return ModellingViewColumnSetRow.idProperty; }
        protected getLocalTextPrefix() { return ModellingViewColumnSetRow.localTextPrefix; }
        protected getNameProperty() { return ModellingViewColumnSetRow.nameProperty; }
        protected getService() { return ModellingViewColumnSetService.baseUrl; }

        protected form = new ModellingViewColumnSetForm(this.idPrefix);

        constructor() {
            super();

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.form.Columns.columnSetCode = this.entityId;
            this.form.Formats.columnSetCode = this.entityId;
        }

        protected arrange() {
            super.arrange();
            var availHeight = $(window).height() - 280;
            this.form.Columns.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
            this.form.Formats.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
        }

        protected updateInterface() {
            super.updateInterface();

            this.form.Columns.set_readOnly(this.form.Columns.get_readOnly() || this.isNew());
            this.form.Formats.set_readOnly(this.form.Formats.get_readOnly() || this.isNew());
        }
    }
}